// How We Work copy. Everything restates terms already published on the site; where we
// have no fixed figure (MOQ, lead time), the copy says it is confirmed in the quote.
const ordering = {
  eyebrow: 'How we work',
  title: 'From inquiry to delivery',
  lead: 'Five steps, two of them yours. Quotes go out within one business day, and nothing is committed until you confirm.',
  photoCaption: 'Quills being sorted and graded before packing.',
  requestQuote: 'Request a quote',
  whatsappLink: 'or message us on WhatsApp',

  processTitle: 'The process',
  yourStep: 'Your step',
  ourStep: 'Our step',
  // `who` is 'you' or 'us' and drives the filled/outlined step markers
  steps: [
    { who: 'you', title: 'Send your requirements', time: 'Any time', detail: 'Grade (or what it’s for), quantity, packaging and destination. Not sure of the grade? Describe the product.' },
    { who: 'us', title: 'We send a quote', time: 'Within 1 business day', detail: 'Priced for your quantity and shipping terms. Samples can go out first if you want to check quality.' },
    { who: 'you', title: 'Confirm and pay', time: 'Proforma within 1 business day', detail: 'Accept the quote, receive the proforma invoice, and pay. Nothing is committed until you confirm.' },
    { who: 'us', title: 'We grade and pack', time: 'Confirmed in your quote', detail: 'Graded, quality-checked and packed to spec: bulk cartons, retail packs or private label.' },
    { who: 'us', title: 'We ship it', time: 'Sea or air', detail: 'Dispatched on the terms you chose, with updates until it arrives.' },
  ],

  termsTitle: 'Order terms',
  termsIntro: 'These apply to every order. Anything specific to yours is set out in the quote.',
  // Same order as the icons in Ordering.js
  terms: [
    { label: 'Minimum order', value: 'Varies by product. Custom volumes on request; unit price depends on quantity.' },
    { label: 'Payment', value: 'Due before production starts. Bank transfer (TT), letter of credit (LC), card or PayPal.' },
    { label: 'Shipping terms', value: 'EXW, FOB, CFR, CIF or DAP, by sea or air.' },
    { label: 'Samples', value: 'Available on request. Sample shipping is charged at cost.' },
    { label: 'Lead time', value: 'Depends on the product and order size. Confirmed in your quote.' },
    { label: 'Private label', value: 'Available. Tell us about your brand and packs.' },
    { label: 'Certifications', value: 'SLS 81 grading, Ceylon Cinnamon PGI, Pure Ceylon Cinnamon logo, GMP, ISO 22000, BRCGS and Halal. EDB-registered exporter.' },
    { label: 'Shipping documents', value: 'Phytosanitary certificate, certificate of origin, certificate of analysis and fumigation certificate.' },
  ],

  ctaTitle: 'Ready for a quote?',
  ctaText: 'Send the grade, quantity and destination. We reply within one business day.',
};

export default ordering;
